export default __webpack_public_path__ + "assets/webgl/intro_1.2193d314.png";